module.exports = __webpack_public_path__ + "media/images/black_history_month/okra-kitchen-5692906ed6cd5cada6b16d6f0fb3390b.png";